import store from '@state/store'

export default (routeTo, routeFrom, next) => {
  store
    .dispatch('property/fetchProperty', {
      property: routeTo.params.permalink,
    })
    .then((property) => {
      routeTo.params.layout = 'bg-screen'
      routeTo.params.layoutComponents = []
      routeTo.params.property = property

      next()
    })
    .catch(() => {
      next({ name: '404', params: { resource: 'Property' } })
    })
}
